import Dropzone from "dropzone";

$(document).ready(function (e) {
    let importDropzone,
        $uploader = $('#imports-uploader'),
        $columns = $('#file-column');


    if ($uploader.length) {
        importDropzone = new Dropzone("#imports-uploader", {
            url: "/imports",
            thumbnailWidth: 40, // px
            thumbnailHeight: 40,
            addRemoveLinks: false,
            maxFilesize: 25, // MB
            autoProcessQueue: true,
            parallelUploads: 1, // Limit to single file upload
            uploadMultiple: false,
            acceptedFiles: ".xlsx,.csv", // Restrict file types to xlsx and csv
            previewTemplate: `<div class="dz-preview dz-file-preview">
                                <div class="dz-details">
                                    <div class="row">
                                        <div class="col-7">
                                            <div class="row">
                                                <div class="col-10 upload-details" >
                                                    <b data-dz-name></b>
                                                </div>
                                                <div class="col-2">
                                                    <i class="fa fa-times remove-attachments" data-dz-remove></i>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div class="col-5">
                                            <div class="upload-progress">
                                                <span class="dz-progress">
                                                    <span class="dz-upload" data-dz-uploadprogress></span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>`
        });

        importDropzone.on("sending", (file, xhr, formData) => {
            formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
        });

        // Remove all uploaded files, reload table and
        // show success toastr.
        importDropzone.on("success", (file, response) => {
            // Use the response from the server here

            if (response.columns && response.columns.length > 27) {
                toastr.error(translation.import_too_many_columns, '', {timeOut: 8000});
                importDropzone.removeFile(file);
                $uploader.attr('data-file', '');
                $uploader.attr('data-columns', '');
                return;
            }

            $uploader.attr('data-file', response.path);
            $uploader.attr('data-columns', JSON.stringify(response.columns));

            $columns.empty();
            $columns.append(`<option value="">${translation.select_column}</option>`)
            $(response.columns).each(function (index, column) {
                $columns.append(`<option value="${index}">${column}</option>`)
            });

            $('.import-mappings-holder').empty();
            $('.test-import').removeClass('validated');

            // importDropzone.removeAllFiles();
            $('.upload-message').addClass('d-none');
            $("#import-step-2").collapse("toggle");
            // toastr.success('Attachment uploaded', '', {timeOut: 5000});
        });


        importDropzone.on("addedfile", (file) => {
            $('.upload-message').removeClass('d-none');
        });

        // Remove file
        importDropzone.on("removedfile", (file) => {
            if (!importDropzone.getQueuedFiles().length) {
                $('.upload-message').addClass('d-none');
            }
        });

        // In case of error, display toastr
        importDropzone.on("error", (file, message) => {
            toastr.error(file.name, message, {timeOut: 5000});
        });
    }

    $('.import-create-modify').change(function () {
        // Check if the selected radio button has value 2 or 3
        if ($(this).val() === "2" || $(this).val() === "3") {
            // If yes, remove the d-none class to show the .show-skip-records div
            $('.show-skip-records').removeClass('d-none');
        } else {
            // If not, add the d-none class to hide the .show-skip-records div
            $('.show-skip-records').addClass('d-none');
        }
    });

    $('.skip-record-fields').selectpicker({
        container: 'body',
        noneSelectedText: translation.nothing_selected
    });

    $('#import-table').on('change', function (e) {
        let id = $(this).val(),
            $picker = $('.skip-record-fields'),
            $child_key = $('#child-key');

        if (id.length) {
            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id,
                    skip_empty: true
                },
                success: function (res) {
                    $picker.selectpicker('destroy');
                    $picker.empty().append(res);
                    $picker.selectpicker({
                        container: 'body',
                        noneSelectedText: translation.nothing_selected
                    });
                    $child_key.append(res);
                    $('.import-mappings-holder').empty();
                }
            });
        }
    });

    $('#parent-table').on('change', function (e) {
        let id = $(this).val();

        if (id.length) {
            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id,
                },
                success: function (res) {
                    $('#parent-key').empty().append(res);
                }
            });
        }
    });

    $('.relation-type').change(function () {
        var selectedValue = $(this).val();

        // If "Mother" is selected, hide child options and show mother options
        if (selectedValue === "mother") {
            $('.child-options').addClass('d-none');

        }
        // If "Child" is selected, hide mother options and show child options
        else if (selectedValue === "child") {
            $('.child-options').removeClass('d-none');
        }
    });

    $('.add-import-mappings').on('click', function (e) {
        let id = $('#import-table').val(),
            columns = $('#imports-uploader').attr('data-columns'),
            file = $('#imports-uploader').attr('data-file');

        if (!file || !file.length) {
            toastr.warning(translation.import_upload_file_first, '', {timeOut: 5000});
            return;
        }

        if (id.length) {
            $.ajax({
                type: "GET",
                url: "/imports/mapping",
                data: {
                    id,
                    columns
                },
                success: function (res) {
                    $('.import-mappings-holder').append(res);
                }
            })
        } else {
            alert('Please select CRM table for Import');
        }
    });

    $('.add-parse-mappings').on('click', function (e) {
        let id = $('#import-table').val(),
            columns = $('#imports-uploader').attr('data-columns');

        if (id.length) {
            $.ajax({
                type: "GET",
                url: "/imports/mapping",
                data: {
                    id,
                    columns
                },
                success: function (res) {
                    $('.import-keys-holder').append(res);
                }
            })
        } else {
            alert('Please select CRM table for Import');
        }
    });

    $(document).on('click', '.remove-import-mapping', function (e) {
        $(this).parents('.import-mapping').remove();
    });

    $(document).on('change', '.import-field-value', function (e) {
        let value = $(this).val(),
            method = $('#http_method').val(),
            $custom_value = $(this).parents('.import-mapping').find('.custom-value'),
            $related_fields = $(this).parents('.import-mapping').find('.related-field'),
            direction = $(this).parents('.import-mapping').find('.mapping-direction').val(),
            $option_holder = $(this).parents('.import-mapping').find('.options-holder'),
            is_related = parseInt($(this).find(':selected').attr('data-is-related')),
            field_name = $(this).find(':selected').attr('data-field-name'),
            field_type = $(this).find(':selected').attr('data-field-type'),
            id = $(this).find(':selected').attr('data-id'),
            type = $(this).find(':selected').attr('data-type'),
            user_fields = ['assigned_to', 'multi_assigned_to', 'created_by', 'updated_by', 'modified_by'],
            related_id = parseInt($(this).find(':selected').attr('data-related-id')),
            options_fields = ['select', 'multiselect', 'multipleselect', 'radio'],
            $integration_field_holder = $(this).parents('.import-mapping').find('.import-field-holder'),
            $related_field_holder = $(this).parents('.import-mapping').find('.related-field-holder'),
            $custom_field_holder = $(this).parents('.import-mapping').find('.custom-value-holder');

        $custom_value.addClass('d-none');
        $related_fields.addClass('d-none');
        $related_field_holder.addClass('d-none');
        $integration_field_holder.addClass('col-12').removeClass('col-6');
        $option_holder.addClass('d-none');

        if (value.length && value === 'custom') {
            if (direction === 'left') {
                $(this).val('');
                alert('Custom value cannot be selected for left mapping direction');
            } else {
                $custom_value.removeClass('d-none');
                $integration_field_holder.removeClass('col-12').addClass('col-6');
                $custom_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            }

        } else if (is_related && related_id) {

            $integration_field_holder.removeClass('col-12').addClass('col-6');
            $related_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            $.ajax({
                type: "GET",
                url: "/settings/integrations/table/fields",
                data: {
                    id: related_id
                },
                success: (res) => {
                    $related_fields.empty().append(res.table_fields).removeClass('d-none');
                }
            });
        } else if (user_fields.includes(field_name)) {
            $integration_field_holder.removeClass('col-12').addClass('col-6');
            $related_field_holder.removeClass('d-none').removeClass('col-12').addClass('col-6');
            $.ajax({
                type: "GET",
                url: '/settings/integrations/table/fields/users',
                data: {
                    id: related_id
                },
                success: (res) => {
                    $related_fields.empty().append(res).removeClass('d-none');
                }
            });
        } else if (options_fields.includes(type)) {
            // $.ajax({
            //     type : "GET",
            //     url : '/settings/integrations/table/fields/options',
            //     data : {
            //         id
            //     },
            //     success : (res) => {
            //         $option_holder.empty().append(res).removeClass('d-none');
            //     }
            // });
        }
    });

    $(document).on('change', '.import-file-field', function (e) {
        let value = $(this).val(),
            $custom_value = $(this).parents('.import-field-container'),
            $custom_field_container = $custom_value.find('.import-file-field-container'),
            $custom_value_container = $custom_value.find('.custom-container');

        if (value === 'custom') {
            $custom_value.find('.custom-value').removeClass('d-none');
            $custom_field_container.removeClass('col-12').addClass('col-6');
            $custom_value_container.removeClass('col-12').addClass('col-6');
        } else {
            $custom_value.find('.custom-value').addClass('d-none');
            $custom_field_container.addClass('col-12').removeClass('col-6');
            $custom_value_container.addClass('col-12').removeClass('col-6');
        }
    });

    $('.test-import').on('click', function (e) {
        e.preventDefault();
        let mappings = getImportMappings(),
            url = $uploader.attr('data-file'),
            $import_errors = $('.import-errors'),
            $btn = $(this),
            $loader = $(this).find('.spinner-border');

        $loader.removeClass('d-none');
        $btn.prop('disabled', true);
        $('.test-import-message').addClass('d-none');

        $import_errors.empty();

        if (mappings) {
            $.ajax({
                type: 'GET',
                url: '/imports/mapping/validate',
                data: {
                    mappings,
                    url
                },
                success: (errors) => {
                    $loader.addClass('d-none');
                    $btn.prop('disabled', false);

                    if (errors.length) {
                        $import_errors.append(errors);
                        $(this).removeClass('validated');
                    } else {
                        $(this).addClass('validated');
                        $('.test-import-message').removeClass('d-none');
                        toastr.success(translation.records_validated);
                        setTimeout(function () {
                            $("#import-step-6").collapse("toggle");
                        }, 3000);
                    }
                }
            })
        } else {
            $loader.addClass('d-none');
            $btn.prop('disabled', false);
        }
    });

    $('.import-data').on('click', function (e) {
        e.preventDefault();
        let mappings = getImportMappings(),
            parse_keys_mapping = getParseKeysMappings(),
            url = $uploader.attr('data-file'),
            $test_import = $('.test-import'),
            $import_errors = $('.import-errors'),
            table = $('#import-table').val(),
            import_action = $('.import-create-modify:checked').val(),
            trigger_automation = $('#trigger-automation').is(':checked') ? 1 : 0,
            trigger_sync = $('#trigger-actions').is(':checked') ? 1 : 0,
            apply_mappings = $('#apply-mappings').is(':checked') ? 1 : 0,
            skip_fields = $('select.skip-record-fields').val(),
            update_empty_values = $('#update_empty_values').is(':checked') ? 1 : 0,
            relation_type = $('.relation-type:checked').val(),
            parent_table = $('#parent-table').val(),
            parent_key = $('#parent-key').val(),
            child_key = $('#child-key').val(),
            file_key = $('#file-column').val(),
            $btn = $(this),
            $loader = $(this).find('.spinner-border');


        $loader.removeClass('d-none');
        $btn.prop('disabled', true);

        $('.import-complete-message').addClass('d-none');

        if ($test_import.hasClass('validated')) {
            toastr.success(translation.import_started);

            $.ajax({
                type: 'GET',
                url: '/import/data',
                data: {
                    mappings,
                    parse_keys_mapping,
                    url,
                    table,
                    import_action,
                    trigger_automation,
                    trigger_sync,
                    apply_mappings,
                    skip_fields,
                    update_empty_values,
                    relation_type,
                    parent_table,
                    parent_key,
                    child_key,
                    file_key
                },
                success: (res) => {
                    $loader.addClass('d-none');
                    $btn.prop('disabled', false);

                    if (res) {
                        $('.import-complete-message').removeClass('d-none');
                        toastr.success(translation.import_completed);
                    }
                }
            })
        } else {
            toastr.info('Please test import before importing');
            $loader.addClass('d-none');
            $btn.prop('disabled', false);
        }
    });

    function getImportMappings() {
        let errors = false,
            $mappings = $('.import-mappings-holder').find('.import-mapping'),
            table = $('#import-table').val(),
            mappings = [],
            user_fields = ['assigned_to', 'multi_assigned_to', 'created_by', 'updated_by', 'modified_by'],
            options_fields = ['select', 'multiselect', 'multipleselect', 'radio'],
            section_mappings = [],
            import_action = parseInt($('.import-create-modify:checked').val()),
            skip_fields = $('select.skip-record-fields').val(),
            relation_type = $('.relation-type:checked').val();

        skip_fields = skip_fields.filter(n => n);

        if (!table.length) {
            errors = true;
            toastr.error('Please select table');
            $("#import-step-2").collapse("toggle");
            return false;
        }

        if (!$mappings.length) {
            errors = true;
            toastr.error('Please add mappings')
            $("#import-step-4").collapse("toggle");
            return false;
        }


        if ((import_action === 2 || import_action === 3) && !skip_fields.length) {
            errors = true;
            toastr.error('Please select skip fields')
            $("#import-step-2").collapse("toggle");
            return false;
        }

        if (relation_type === 'child') {
            let parent_table = $('#parent-table').val(),
                parent_key = $('#parent-key').val(),
                file_column = $('#file-column').val(),
                child_key = $('#child-key').val();

            if (!parent_table.length) {
                errors = true;
                toastr.error('Please select parent table')
                $("#import-step-3").collapse("toggle");
                return false;
            }

            if (!parent_key.length) {
                errors = true;
                toastr.error('Please select parent key')
                $("#import-step-3").collapse("toggle");
                return false;
            }

            if (!file_column.length) {
                errors = true;
                toastr.error('Please select file column')
                $("#import-step-3").collapse("toggle");
                return false;
            }

            if (!child_key.length) {
                errors = true;
                toastr.error('Please select child key')
                $("#import-step-3").collapse("toggle");
                return false;
            }
        }

        $mappings.each(function (index, $mapping) {
            let field = $($mapping).find('.import-field-value').val(),
                is_related = parseInt($($mapping).find('.import-field-value').find(':selected').attr('data-is-related')),
                field_name = $($mapping).find('.import-field-value').find(':selected').attr('data-field-name'),
                type = $($mapping).find('.import-field-value').find(':selected').attr('data-type'),
                field_type = $($mapping).find('.import-field-value').find(':selected').attr('data-field_type'),
                related_id = $($mapping).find('.related-field').val(),
                file_column = $($mapping).find('.import-file-field').val(),
                custom_value = $($mapping).find('.custom-value').val(),
                payload = {};

            if (!field.length) {
                errors = true;
                toastr.error('Please select mapping field')
                $("#import-step-4").collapse("toggle");
                return false;
            }

            if (!file_column.length) {
                errors = true;
                toastr.error('Please select column from file')
                $("#import-step-4").collapse("toggle");
                return false;
            }

            payload = {
                field: field,
                type: '',
                value: '',
                is_custom: 0,
                select_values: [],
                file_column
            };

            if (file_column === 'custom') {
                payload.type = 'normal';
                payload.is_custom = 1;
                payload.value = custom_value;
            }

            if (is_related) {
                payload.type = 'related';
                payload.related_id = related_id;
            }

            if (user_fields.includes(field_name)) {
                payload.type = 'user_field';
                payload.related_id = related_id;
            }

            mappings.push(payload);
        });

        return mappings;
    }

    function getParseKeysMappings() {
        let errors = false,
            $mappings = $('.import-keys-holder').find('.import-mapping'),
            table = $('#import-table').val(),
            mappings = [],
            user_fields = ['assigned_to', 'multi_assigned_to', 'created_by', 'updated_by', 'modified_by'];

        if (!table.length) {
            errors = true;
            toastr.error('Please select table');
            $("#import-step-2").collapse("toggle");
            return false;
        }

        $mappings.each(function (index, $mapping) {
            let field = $($mapping).find('.import-field-value').val(),
                is_related = parseInt($($mapping).find('.import-field-value').find(':selected').attr('data-is-related')),
                field_name = $($mapping).find('.import-field-value').find(':selected').attr('data-field-name'),
                type = $($mapping).find('.import-field-value').find(':selected').attr('data-type'),
                field_type = $($mapping).find('.import-field-value').find(':selected').attr('data-field_type'),
                related_id = $($mapping).find('.related-field').val(),
                file_column = $($mapping).find('.import-file-field').val(),
                custom_value = $($mapping).find('.custom-value').val(),
                payload = {};

            if (!field.length) {
                errors = true;
                toastr.error('Please select mapping field')
                $("#import-step-4").collapse("toggle");
                return false;
            }

            if (!file_column.length) {
                errors = true;
                toastr.error('Please select column from file')
                $("#import-step-4").collapse("toggle");
                return false;
            }

            payload = {
                field: field,
                type: '',
                value: '',
                is_custom: 0,
                select_values: [],
                file_column
            };

            if (file_column === 'custom') {
                payload.type = 'normal';
                payload.is_custom = 1;
                payload.value = custom_value;
            }

            if (is_related) {
                payload.type = 'related';
                payload.related_id = related_id;
            }

            if (user_fields.includes(field_name)) {
                payload.type = 'user_field';
                payload.related_id = related_id;
            }

            mappings.push(payload);
        });

        return mappings;
    }
});